var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.getLearningGoalActivities,"no-data-text":_vm.$t('Keine Aktivitäten verfügbar'),"label":_vm.$t('Aktivitäten'),"hint":_vm.computedHint,"persistent-hint":"","return-object":"","item-text":"name"},model:{value:(_vm.computedSelect),callback:function ($$v) {_vm.computedSelect=$$v},expression:"computedSelect"}})
}
var staticRenderFns = []

export { render, staticRenderFns }